export default "__VITE_PUBLIC_ASSET__96baa1e3__"